import { render, staticRenderFns } from "./IdentityVerificationStepper.vue?vue&type=template&id=0db2c479&scoped=true"
import script from "./IdentityVerificationStepper.vue?vue&type=script&lang=js"
export * from "./IdentityVerificationStepper.vue?vue&type=script&lang=js"
import style0 from "./IdentityVerificationStepper.vue?vue&type=style&index=0&id=0db2c479&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db2c479",
  null
  
)

export default component.exports